"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setUnreadMessages = void 0;
const set_unread_count_1 = require("@app/action/set-unread-count");
const create_ac_1 = require("./util/create-ac");
exports.setUnreadMessages = (0, create_ac_1.createAC)(async (dispatch, unreadCount) => {
    dispatch((0, set_unread_count_1.setUnreadCountAction)(unreadCount));
});
